export const FirebaseConfig = {
	"projectId": "bebwa-ab5c6",
	"appId": "1:983936970001:web:2af100e635c4c29469b0b0",
	"databaseURL": "https://bebwa-ab5c6-default-rtdb.asia-southeast1.firebasedatabase.app",
	"storageBucket": "bebwa-ab5c6.firebasestorage.app",
	"apiKey": "AIzaSyBpDcFpMa3kaofT9k3iokxn6eHI2pohKsA",
	"authDomain": "bebwa-ab5c6.firebaseapp.com",
	"messagingSenderId": "983936970001",
	"measurementId": "G-THX7BLPZL8",
	"projectNumber": "983936970001",
	"version": "2"
};